module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("A Cry from the Dust")]), _c('link', {
    attrs: {
      "href": "css/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ct"
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contents#ff2",
      "id": "fr2"
    }
  }, [_vm._v("CHAPTER")])]), _c('p', {
    staticClass: "ct1"
  }, [_c('a', {
    attrs: {
      "href": "#/contents#ff2"
    }
  }, [_c('b', [_vm._v("TWO")])]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("A YOUNG MAN DOVE TO HER SIDE")]), _vm._v(". “BEKKA—” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Call a doctor,” someone yelled.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Oh dear!” I knelt beside the fallen girl. The crowd lapped around us like a human ocean.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Miss? Are you hurt?” I picked up her limp hand and looked around for help. “Please, someone call 911.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Bekka? Oh Lord, is she dead?” the young man asked.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('i', [_vm._v("Dead?")]), _vm._v(" I touched her neck and felt a reassuring "), _c('i', [_vm._v("thump-thump-thump.")]), _vm._v(" “No.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("An older woman with short gray hair pushed through. “I’m a nurse. Please, everybody move back and stay calm.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I slid out of the way as the nurse took my place and checked her carotid pulse.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“What’s wrong with her?” the young man asked.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“She probably just fainted. Please, everyone move back.” The nurse gently rubbed the girl’s face.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("I stood. “Did someone call 911?” ")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("“Yeah. They’re coming,” Craig answered. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The young woman seemed to be in capable hands, so I trotted to the entrance to direct the EMTs. They soon arrived in a flurry of lights. Two men carrying medical cases charged through the door and raced in the direction I pointed. I slowly followed, not wanting to get in the way.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Did the girl faint because of a medical condition, or did my reconstruction have something to do with it? She had been staring right at the sculpture when she collapsed. But nothing about my work was gory, just clay over a plaster casting.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The voice on the loudspeaker announced the center would close in thirty minutes. The visitors meandered toward the exits, and I could see the EMTs talking to the young woman, now sitting cross-legged on the floor.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I felt a rush of relief that she wasn’t hurt.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I’m so sorry,” the girl said. “I feel so embarrassed.” She smiled when she saw me. “I guess I gave you all quite a scare.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“As long as you’re okay.” I nodded to the apparent boyfriend. “Are "), _c('i', [_vm._v("you")]), _vm._v(" all right?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Yeah.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I glanced at the offending reconstruction. Someone had shoved the stands holding Curly and Moe against the wall. The third stand lay on the floor, Larry’s sculpture smashed.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Bile rose in the back of my throat, and I covered my mouth to keep from crying out. Five days of labor lay ruined.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("I moved closer and picked up a plastic container holding the backup skulls. The ominous rattle made my stomach turn. The castings were in pieces. No way could I finish by the opening. Though the Utah work was satisfying, I’d been looking ")]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("forward to returning home soon, picking up Aynslee from boarding school, and starting fresh. Now I’d be here another week at least. And Aynslee would be another week more resentful. The academy seemed like such a great solution when this job opened up. Robert was traveling and couldn’t, or wouldn’t, take our daughter, and I couldn’t have a rebellious teen hanging out at the motel while I worked. And I desperately needed this work.")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("I could hear my best friend’s, Beth Noble’s, voice in my head: "), _c('i', [_vm._v("“Everything happens for a reason.”")]), _vm._v(" The problem was I could never figure out the reason. "), _c('i', [_vm._v("Just once, God, couldn’t You show me why?")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("No use whining. Maybe I could sculpt a smile on the settler’s face the next time.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I turned away. The EMTs helped the girl to her feet, and the young man wrapped a protective arm around her waist. I caught up with her. “Excuse me?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Yes?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Are you okay?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Yeah, sure.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Well . . . uh . . . good, that’s good.” I glanced at the sculpture. “I sometimes forget folks aren’t used to watching CSI-type work.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I love those shows.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“But most of that is make-believe. Maybe seeing real forensic work—” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Oh, that. I found it fascinating.” She looked away. A moment passed. “It’s just, well. Actually, I was, uh, not feeling well.” She leaned on her boyfriend and drifted toward the exit.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She’d just lied to me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Just before the door shut behind her, she glanced back.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("Getting the vapors had gone out of style in the Victorian era along with whalebone corsets.")])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("The protestors had left, as well as the biker. Some families and the tour group still hovered around the refreshments. I sauntered through the rapidly thinning crowd to where Craig leaned against a display case. “Craig, can you do me a favor?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“If I get you a name, would you check on it for me?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Is it a case you’re working on?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Maybe—” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“The center will be closing in five minutes.” The loudspeaker echoed.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Craig looked toward the exit. “Don’t tell me. You want to check out that fainting girl. You’re doing your Superman Syndrome routine again.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I clamped my mouth shut on a nasty retort. Superman Syndrome referred to forensic artists who overstepped their duties and tried to solve a case single-handed. “Never mind.” I probably didn’t need his help. These days, once I had a name and a little information, I could do more research about someone on a social network.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We said our good-byes as the last of the people strolled toward the exits. Bentley Edwards gathered his docents, four gray-haired women newly hired for the job, and escorted them out.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("Someone had kicked the neon-blue tarp under my work area into a pile, and the tan plastic boxes lay on their sides. I tugged the tarp flat, replaced the brass posts holding the velvet ropes, and straightened the books. The sculpting tools appeared unharmed, but even with expedited service, the new skull casts wouldn’t arrive until tomorrow. Plus, I’d probably have to pay for ")]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("that out of my own pocket until the insurance company reimbursed me.")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("I picked up Larry’s smashed face off the floor. The soft oil-based clay used in the reconstruction now had embedded plaster chips. A clear footprint, made by a woman-size shoe, mashed down the facial features.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I dumped the work into a nearby trash can. Larry’d been the first reconstruction I’d completed, and it was like losing a buddy. I gripped the edge of the bin. "), _c('i', [_vm._v("Good-bye, m’ friend.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("One final bit of cleanup near where the girl had fallen yielded a maroon backpack with a broken latch. I carefully turned it over. No name appeared in the clear plastic holder sewn into the flap. I should turn the backpack over to lost and found.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('i', [_vm._v("I should.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But if it belonged to the fainting girl, she’d be leaving town soon with her college group. A quick peek at the wallet would give me an identification of the owner.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("That’s snooping.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("No. Identifying the owner was just being thoughtful. I was heading to town, and if there was a clue to the owner, I could return it. I opened the backpack. The pink fake leather wallet gave me the name of Rebekah Kenyon, c/o North Idaho College. "), _c('i', [_vm._v("Rebekah. Bekka?")]), _vm._v(" The college address matched the logo on the girl’s shirt. I returned the wallet and placed the backpack with my purse and lunch cooler.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Maybe if I spoke to her alone, she’d tell me why she fainted. And why she lied.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("After sitting on the high work stool, I stared at Curly’s face. The blue eyes gazed upward above pronounced cheekbones ")]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("and a slender jaw. The anthropologists described him as a man in his late forties to fifties, with a chip in his front tooth and left zygomatic bone, suggesting old injuries. I created a scar across the cheek, but, like all forensic artists working on unknown skulls, I guess at the parts of the face consisting of soft tissue: the eyelids and exact shape of the nose, lips, and ears.")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("I patted the clay cheek. “Well, Curly, you and Moe survived the day. Looks like you’re still making the ladies swoon. Just wait until I give you more hair.” I smoothed the clay on his temple. “You have to admit the girl’s reaction was strange. It was like she saw the face of someone she knew.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Minuscule tentacles of unease tripped across my shoulders. I shrugged them away. “I’m sorry to break this to you, but you’ve been dead for over a hundred and fifty years.” I squinted at my work. “Although you don’t look your age—” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Excuse me? Is someone still with you, Gwen?” George Higbee, the elderly security guard, peered around the room.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Just talking to my buddy here.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("George shoved his thick tortoiseshell glasses up the bridge of his nose and shuffled over. A widower, he was jockey-small, with a full head of ginger-and-white hair. “You’ll need a permit and pass if you’re having someone stay after hours.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“See?” I addressed the skull. “Now you need a green card.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The guard stopped, then scratched his head. “Are you talking to that . . . that thing?”")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("“Careful, George, Curly’s got ears, you know. Well, okay, one ear. I’ll give him another one tomorrow.” I smiled at his expression. “Never mind. I’m leaving for the evening.” I checked my watch. It was much later than I thought. George usually ushered me out long before this. “Thank you again for the slice of ")]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("banana bread. It was delicious.” "), _c('i', [_vm._v("Maybe he’ll invite me to dinner ")]), _c('i', [_vm._v("again sometime soon.")]), _vm._v(" He was a marvelous chef.")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("George ducked his head. “’Twas nothing.” He squinted at the two heads. “They give me the creeps, you know. Like they are still mad or want revenge.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“They’re harmless, George.” I took out my digital camera and photographed the day’s work, jotted the progress in my notebook, and loaded my oversize purse. George moved closer and stared at my work. I couldn’t read his expression.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“George?” He didn’t seem to hear me. “George?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Like a man waking up from sleep, he finally looked at me. “Oh. Sorry. Say, missy, I didn’t ask. How did today go?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Interesting. Quite the drama.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("His gaze seemed to sharpen. “How so?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Several arguments. A lady was almost knocked to the floor. A young woman fainted—” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Fainted?” He nodded. “That would explain it.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Explain what?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He glanced away and cleared his throat. “Nothing. Ready to leave?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I nodded. He followed me to the exit and opened the door. I strolled past him to my car, parked in the employee’s lot next to George’s Jeep and someone’s blue pickup. I dumped everything in the trunk and slipped into the driver’s seat. The interior was oven-hot, even with the windshield cover. I cranked up the air-conditioning and let it run a bit while I called the casting company.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Skull-Duggery. How may I direct your call?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I’d like to place an order.” I pulled my credit card from my wallet as I waited for the sales rep.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("“Customer service, how—” ")])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("The roar of the truck’s diesel engine drowned out her words. George’s Jeep was in the way, but through the Jeep’s dusty windows I could just make out a figure in the blue pickup. “What’s he doing?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“What’s who doing?” The voice on the phone sounded suspicious.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Oh, sorry—” The engine roared again.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“—can’t hear you.” The woman’s voice was irritated.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I’d like to place an order.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The truck revved again, belching diesel fumes, and backed up. I turned to see if I could read the license plate, but the truck shot from the parking area before I could see anything. It was probably just someone talking on the phone like I was.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Maybe he was looking for something. Or waiting for someone . . .")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I missed your answer. Have you ordered from us before?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Yes.” I quickly placed the order, and she assured me I’d have the skulls the next day, quoting an expedited shipping fee that made me wince. I hung up and tossed the phone in my purse.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Mountain Meadows was a verdant paradise in 1857, but I now drove through a God-cursed, arid wasteland toward the community of Fancher, named after the leader of the doomed wagon train. The new businesses forming the town were as colorful as the surrounding landscape was desolate. Fancher was one street wide, sprouting less than a mile from the Mountain Meadows site.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("The only hotel, the Baker Inn, was my residence for the past few weeks. Except for the occasional dinner invitations to George’s home, I’d subsisted on restaurant chow. I’d memorized ")]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_vm._v("the menu. As I never mastered even the simplest cooking skills, I’d enjoyed that part of the stay. The room was clean enough, and I’d made a game of seeing what housekeeping would forget to replenish each day: plastic-wrapped cups, hand towel, or shampoo instead of another bottle of conditioner to go with the three already there. I gave up on hoping they’d leave me regular coffee packets instead of decaf. I bought my own.")])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("A silver-and-red bus with a North Idaho College logo straddled the motel parking area. I parked and slipped from the car. My cell phone rang as I approached the lobby. I rummaged in my purse. “Gwen Marcey.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“You have an obstreperous dog.” Beth sounded breathless.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Is that your word of the day?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Yes. It means unruly, but also noisy.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Ah. What has Winston done this time?” The clerk approached from the rear of the building. “Hold on, Beth.” I pulled the phone from my ear. “Hi, Joyce. Any messages or packages?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Joyce shook her head. “FedEx hasn’t come yet. No messages. How’d the preview opening go?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Quite the drama. A young gal fainted by my display. I need to return her backpack. She’s probably with that college group.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I think everyone’s at dinner.” She nodded at the cafe on the side of the building.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Beth? Still there?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“What fainting woman? Are you doing some sleuthing while I’m stuck here taking care of your dog? Don’t you realize I’m going crazy bored without you here telling me about your cases? Where would Sherlock be without Watson?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Smoking opium and playing the violin.”")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v("“Correction. Watson knew Sherlock smoked opium and was often around when Holmes played the violin.”")])]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("“I should never try to be funny with a research software engineer.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I’m retired and that wasn’t funny.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I reached the door. “I’ll call you a bit later for a blow-by-blow account. Do we have a dog emergency?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“No.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Good. I need to try to catch up with this girl before she leaves town.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Promise you’ll call?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Promise.” I dropped the cell into my pocket. I once made the mistake of playing Scrabble with Beth. She thoroughly stomped me, using words like "), _c('i', [_vm._v("zwieback")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A blue pickup trolled past on the main street, speeding up as I watched. It looked like the same pickup I’d seen parked at the interpretive center.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I headed over to speak to the girl. I couldn’t wait to get to my room, relax, take off my incredibly itchy wig, and veg out.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Crossing to the restaurant, I folded my arms to ward off the cool gust of high desert wind. Though still August, the fragrance of autumn was in the air. So was the smell of steak and garlic. My mouth watered. Maybe I’d order the number seven. Or the number two. Roasted chicken with garlic mashed potatoes.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v("I nodded at the hostess and glanced around the spacious room. The college students occupied almost every table and half the counter, all trying to talk over their neighbors. Dishes clanked, silverware clattered, and waitresses leaned close to hear the meal orders. I didn’t see Rebekah. The only person I recognized was the young man sitting alone against the wall. He would know ")]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("how I could get in touch with the fainting girl. I strolled over. “How’s your friend, Bekka?” I had to speak up to be heard.")])]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("“Uh, she went to her room . . . to change . . . and said she’d be down soon.” He wiped his hands on a napkin.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“No injuries from the fall?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Said she was okay.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Did she say why she fainted?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“She said she was hungry and sick.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Oh.” I waited to see if he’d offer any other information. “I’m Gwen Marcey, by the way.” I tugged out a business card and handed it to him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Ethan Scott.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Okay, Ethan. I just wanted to see how she was doing. I have something of hers. Will she be long?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He glanced at his watch. “She should have been here by now.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Unease pricked my neck. “Maybe we should check on her. She might have fainted again.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The young man lurched to his feet. “I didn’t think about that.” His eyes widened, and he clutched the napkin in a white-knuckled fist. “She’s in room twenty. All the way at the far corner. I have a key.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('i', [_vm._v("Hmm. More than a casual boyfriend?")]), _vm._v(" I raised my eyebrows, and the man’s face turned lobster red. He threw some bills on the table to cover his cola.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("The rooms of the two-story building faced the densely landscaped parking area and formed a U shape around a pool. The lobby and meeting rooms faced the main road and completed the top of the U. Breezeways allowed access to the center of the complex, and sliding-glass doors opened to the pool area from the ground-floor units. No traffic sounds drifted to this ")]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v("part of the motel. Coincidentally, my room was directly above Rebekah’s.")])]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("I rapped sharply on the door. “Bekka? Rebekah Kenyon?” My voice sounded loud in the still air.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("No answer.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I raised my fist to knock again, but a large fly hummed past my face. I swatted at it. The bug landed on the window, then tapped against the glass. A second fly buzzed around me before landing by my foot and sliding under the entry.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The tiny hairs on my arms rose. I grabbed the key card from Ethan and shoved it into the lock. After glancing at the boyfriend’s pale face, I used the edge of my shirt to gently turn the knob, then nudged the door open with my elbow.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The metallic stench was unmistakable.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-371142dd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter5.vue
// module id = 84
// module chunks = 0